var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1965 7.54222C13.5864 7.64862 13.9586 7.80798 14.2951 8.00297L15.6601 7.17004L16.83 8.33998L15.9793 9.68714C16.1921 10.0415 16.3514 10.4137 16.4578 10.8036L18 11.1758V12.8243L16.4578 13.1965C16.3514 13.5864 16.1921 13.9586 15.9793 14.2951L16.83 15.6601L15.6601 16.83L14.3129 15.9793C13.9585 16.1921 13.5864 16.3514 13.1964 16.4578L12.8242 18H11.1758L10.8036 16.4578C10.4136 16.3514 10.0414 16.1921 9.68709 15.9793L8.33992 16.83L7.16998 15.6601L8.00291 14.3129C7.80792 13.9585 7.64855 13.5864 7.54216 13.1964L6 12.8242V11.1758L7.54216 10.8036C7.64856 10.4136 7.80792 10.0414 8.00291 9.68709L7.16998 8.33992L8.33992 7.16998L9.68709 8.00291C10.0414 7.80792 10.4136 7.64855 10.8036 7.54216L11.1758 6H12.8242L13.1965 7.54222ZM11.9914 8.58793C10.1127 8.58793 8.58847 10.1122 8.58847 11.9908C8.58847 13.8873 10.1127 15.4116 11.9914 15.4116C13.8879 15.4116 15.4121 13.8873 15.4121 11.9908C15.4121 10.1122 13.8879 8.58793 11.9914 8.58793Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.0c201089fe9c17a81e31d899a496fa1a.svg";
export { ForwardRef as ReactComponent };